import {map, Observable} from 'rxjs';

import {IGetBase64WithFieldsRequest, IGetBase64WithFieldsResponse, IGetCycleFieldsResponse} from '@core/api/data-access';
import {StoredFile} from '@global-data';

import {CyclesService} from './cycles.service';

export class FieldsCyclesService {
	constructor(private cyclesService: CyclesService) {}

	/**
	 * Get cycle field
	 * @param cycleId cycle id
	 * @param allStations true to receive the list of all field (default: false)
	 * @param withMetaData true to receive also metadata (already included in all) (default: false)
	 * @param stationOrdinal non-zero index of a station to get only the field in that station (overrides all, metadata is optional) (default: 0)
	 */
	getCycleFields(cycleId: string, allStations = false, withMetaData = false, stationOrdinal = 0): Observable<IGetCycleFieldsResponse> {
		const params = {id: cycleId, all: allStations, metadata: withMetaData, station: stationOrdinal};
		return this.cyclesService.apiService.get<IGetCycleFieldsResponse>(this.cyclesService.getUrl(`fields`), params);
	}

	getDocumentFields(base64: string): Observable<IGetBase64WithFieldsResponse> {
		const storedFile = new StoredFile(base64, 'pdf');
		const request: IGetBase64WithFieldsRequest = {fileData: storedFile.fileEncode};
		return this.cyclesService.apiService.post<IGetBase64WithFieldsResponse, IGetBase64WithFieldsRequest>(this.cyclesService.getUrl(`fields`), request).pipe(
			map(r => {
				return {
					fields: r.fields,
					fileData: storedFile,
				};
			}),
		);
	}
}
